import styled from "styled-components";

export const CardsGrid = styled("div")`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
  padding: 0px 10px 0px 10px;
  
  @media(min-width: 768px){
    grid-template-columns: repeat(2, 1fr);
    padding: 0px 0px 0px 0px;
  }

  @media(min-width: 1024px){
    grid-template-columns: repeat(3, 1fr);
  }

  @media(min-width: 1200px){
    grid-template-columns: repeat(3, 1fr);
  }
`;